module.exports = __webpack_public_path__ + "static/media/dummy.40deb969.jpg";